import {useEffect} from 'react';

import packageJson from '@primer-io/checkout-web/package.json';

import {insertLink} from 'libs/utils/insertLink/insertLink';

/**
 * hook for preload PrimerCoreSDK.min.js and Checkout.css
 */
export const usePreloadPrimer = () => {
    const PRIMER_URL = 'https://sdk.primer.io/web/v';
    useEffect(() => {
        insertLink({
            as: 'script',
            href: `${PRIMER_URL}${packageJson.version}/PrimerCoreSDK.min.js`,
            rel: 'preload',
        });
        insertLink({
            href: `${PRIMER_URL}${packageJson.version}/Checkout.css`,
            rel: 'stylesheet',
        });
    }, []);
};
